import {
  ByRouteRowItem,
  VolumeAndTargetList,
} from "../../types/route-pair.types";
import { transformResultCommonFieldsToTableRow } from "./CommonTableRowTransformer";
import { StatisticsResultListItem } from "@/features/statistics/config/ResultTableConfig";
import { ByCustomerOrVolume } from "@/features/statistics/types/ByCustomerOrVolumeEnum";

export const transformResultToTableRow = (
  row: ByRouteRowItem,
  volumeAndRates: VolumeAndTargetList,
  checkedRadioButton: ByCustomerOrVolume
): StatisticsResultListItem => {
  const volumeAndTargetForSelected = volumeAndRates.find(
    (v) => v.routePair.id === row.routePair.id
  )?.volumeAndTargetForSelected;

  return {
    ownerId: row.routePair.id,
    ownerName: row.routePair.code,
    routePair: row.routePair.description,
    ...transformResultCommonFieldsToTableRow(row, checkedRadioButton),
    ...{
      ...volumeAndTargetForSelected,
    },
  };
};
